export const themeData6 = {
  showRating: true,
  ratingBg: '#9F8DD2',
  showBtn: true,
  btnTextColor: '#fff',
  btnHoverTextColor: '#fff',
  btnHoverBgColor: '#9F8DD2',
  btnBgColor: '#9F8DD2',
  borderRadius: '30',
  borderColor: '#9F8DD2',
  addedCartText: 'Added to cart',
  addCartText: 'Add to cart',
  showSelectBox: true,
  selectBorderColor: '#8B8B8B',
  selectColor: '#8B8B8B',
  soldOutText: 'Sold Out',
  soldOutTextColor: '#fff',
  soldOutBgColor: '#FFFFFF',
  soldOutPosition: 'top-right',
  titlePorition: 'flex-start',
  bgColor: '#FFFFFF',
  TitleColor: '#010101',
  bgImgColor: '',
  productTitleColor: '#030303',
  priceColor: '#7F769B',
  originalPriceColor: '#B1B1B1',
  heightDesktopImage: '236',
  widthDesktopImage: '236',
  heightMobileImage: '236',
  widthMobileImage: '236'
};
